<template>
  <div class="not-found-page">
    <nav-bar />

    <el-main class="error-container">
      <div class="error-content">
        <div class="error-code">
          <span>4</span>
          <div class="circle">
            <i class="el-icon-video-pause"></i>
          </div>
          <span>4</span>
        </div>

        <h1 class="error-title">哎呀，页面断片了...</h1>
        <p class="error-msg">你请求的地址可能被外星人劫持，或者已经下架了。</p>

        <div class="error-actions">
          <el-button type="primary" round class="action-btn" @click="goIndex">
            返回首页
          </el-button>
          <el-button round class="action-btn" @click="goBack">
            返回上一页
          </el-button>
        </div>
      </div>
    </el-main>
  </div>
</template>

<script>
import NavBar from '@/components/layout/LoginBar'

export default {
  name: 'NotFound',
  components: {
    NavBar
  },
  methods: {
    goIndex() {
      this.$router.push('/')
    },
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">
.not-found-page {
  background-color: #f6f8fa;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.error-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.error-content {
  text-align: center;
  max-width: 500px;
  width: 100%;
}

.error-code {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 120px;
  font-weight: 900;
  color: #fe2c55; // 使用你搜索框的主题红
  line-height: 1;
  margin-bottom: 20px;

  .circle {
    width: 100px;
    height: 100px;
    background: #fff;
    border-radius: 50%;
    margin: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 10px 20px rgba(254, 44, 85, 0.1);

    i {
      font-size: 60px;
      animation: pulse 2s infinite;
    }
  }
}

.error-title {
  font-size: 24px;
  color: #333;
  margin-bottom: 15px;
}

.error-msg {
  font-size: 16px;
  color: #9499a0;
  margin-bottom: 40px;
}

.error-actions {
  display: flex;
  justify-content: center;
  gap: 15px;

  .action-btn {
    padding: 12px 30px;
    font-weight: 600;
    transition: all 0.3s;

    &:hover {
      transform: translateY(-2px);
    }
  }
}

/* 简单的呼吸灯动画 */
@keyframes pulse {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(0.9); opacity: 0.7; }
  100% { transform: scale(1); opacity: 1; }
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .error-code {
    font-size: 80px;
    .circle {
      width: 70px;
      height: 70px;
      i { font-size: 40px; }
    }
  }

  .error-title {
    font-size: 20px;
  }

  .error-msg {
    font-size: 14px;
    padding: 0 20px;
  }

  .error-actions {
    flex-direction: column;
    padding: 0 40px;
    gap: 10px;

    .el-button {
      margin-left: 0 !important;
      width: 100%;
    }
  }
}
</style>
